import React, { useContext, useRef } from 'react'

import { Grid, Typography, Box, Stack } from '@mui/material'

import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import Card from 'atoms/Card'
import { Masonry } from '@mui/lab'
import Banner from 'atoms/Banner'

import { motion } from 'framer-motion'
import ToDoList from '../newdash/components/ToDoList'
import LifeInsuranceTable from './components/LifeInsuranceTable'
import LifeInsuranceSummary from './components/LifeInsuranceSummary'

import meeting from 'assets/images/icons/meeting-background.svg'

import ScoreCard from 'components/ScoreCard'
import { ScheduleAppointment } from 'components/ScheduleAppointment'
import lifeInsuranceUnlock from 'assets/images/lifeInsuranceUnlock.png'
import { useModal } from 'components/modals'
import { IntakeContext } from 'context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { steps } from 'layouts/onboarding'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const Fegli = () => {
  const { openModal } = useModal()
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const remainingInsuranceSteps = useRef(
    steps.filter((step) => step.tags?.includes('fegli'))
  )
  const items = [
    // <motion.div
    //   key="gap"
    //   layout
    //   initial={{ opacity: 0, scale: 0.95 }}
    //   animate={{ opacity: 1, scale: 1 }}
    //   transition={{ duration: 0.4, ease: 'easeInOut' }}
    // >
    //   <Card
    //     header={
    //       <Banner
    //         color="green"
    //         type="header"
    //         actionText="BRIDGE MY GAP"
    //         title="MY LIFE INSURANCE GAP"
    //         description={dollarFormat.format(99711)}
    //         subText={`/ ${dollarFormat.format(1400000)}`}
    //       />
    //     }
    //   >
    //     <LifeInsuranceTable />
    //   </Card>
    // </motion.div>,
    <>
      {intakeState?.dateOfBirth != null &&
      intakeState?.dateOfPlannedRetirement != null &&
      (intakeState?.privateLifeInsurance || intakeState?.fegli) ? (
        <LifeInsuranceSummary key="summary" />
      ) : (
        <motion.div
          key={1}
          // style={{ minWidth: '500px' }}
          layout
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
        >
          <Banner
            color={''}
            type={'unlock'}
            actionText="SEE YOUR LIFE INSURANCE SUMMARY"
            clickAction={() => {
              openModal('questionModal', {
                modalHeader: 'Unlock Life Insurance Summary',
                steps: remainingInsuranceSteps.current,
                completionStepProps: {
                  header: 'Life Insurance Summary Unlocked!',
                  subHeader:
                    'Head back to the dashboard to unlock more tiles or complete To-Do items!',
                },
              })
            }}
            title="UNLOCK TILE"
            description="Life Insurance Summary"
            subText=""
            content={
              <>
                <img
                  style={{
                    objectFit: 'cover',
                    width: '250px',
                    marginTop: '64px',

                    boxShadow: '0px 4px 25px -8px #00000033',
                  }}
                  src={lifeInsuranceUnlock}
                />
              </>
            }
          />
        </motion.div>
      )}
    </>,
    // <LifeInsuranceSummary key="summary" />,
    <ToDoList
      key="todo"
      items={[
        {
          header: 'Update Life Insurance Information',
          completed:
            (intakeState?.privateLifeInsurance &&
              intakeState?.privateLifeInsurance.length > 0) ||
            intakeState?.fegli
              ? true
              : false,
          onClick: () =>
            openModal('questionModal', {
              modalHeader: 'Update Life Insurance Summary',
              steps: remainingInsuranceSteps.current,
              completionStepProps: {
                header: 'Life Insurance Summary Updated!',
                subHeader:
                  'Close this window and unlock more tiles or complete To-Do items!',
              },
            }),
        },
        {
          header: 'Add Additional Life Insurance Policy',
          completed:
            intakeState?.privateLifeInsurance &&
            intakeState?.privateLifeInsurance.length > 0
              ? true
              : false,
          onClick: () =>
            openModal('addLifeInsurance', {
              intakeState: intakeState,
              updateIntakeStateAndSubmit: updateIntakeStateAndSubmit,
              updateIntakeStateAtKey: updateIntakeStateAtKey,
            }),
        },
        {
          header: 'Set up a Will',
          completed: intakeState?.hasWill ? true : false,
          onClick: () =>
            openModal('willSimple', {
              updateIntakeStateAndSubmit: updateIntakeStateAndSubmit,
              updateIntakeStateAtKey: updateIntakeStateAtKey,
            }),
        },
        {
          header: 'Set up a Trust',
          completed: intakeState?.hasTrust ? true : false,
          onClick: () =>
            openModal('willSimple', {
              addTrust: true,
              updateIntakeStateAndSubmit: updateIntakeStateAndSubmit,
              updateIntakeStateAtKey: updateIntakeStateAtKey,
            }),
        },
      ]}
    />,
    // <ScoreCard key="score" value={94} goal={'December 2025'} type="legacy" />,
    <motion.div
      key="schedule"
      // style={{ minWidth: '500px' }}
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
      onClick={() => openModal('scheduleAppointment')}
    >
      <Banner
        color={'blue'}
        type={'banner'}
        actionText="TALK TO AN ADVISOR"
        title=""
        description="Schedule a Free Review"
        subText="Click here to speak with a PARCO team member"
        content={
          <>
            <img
              style={{
                objectFit: 'cover',
                paddingTop: '16px',
                width: '100px',
              }}
              src={meeting}
            />
          </>
        }
      />
    </motion.div>,
  ]

  return (
    <DashboardLayout>
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
        pb={6}
      >
        <Grid item xs={12} mb={4} mt={8} display={'flex'}>
          <Typography
            fontWeight="400"
            fontSize="28px"
            textAlign="left"
            color="#262627"
          >
            <Box sx={{ display: 'inline-block', fontWeight: 600 }}>
              Life Insurance
            </Box>{' '}
            - Make sure your legacy is secured
          </Typography>
        </Grid>

        <Box display={{ xs: 'block', xxl: 'none' }}>
          <Stack spacing={6}>
            {items.map((item, i) => (
              <Box key={i}>{item}</Box>
            ))}
          </Stack>
        </Box>

        <Box display={{ xs: 'none', xxl: 'flex' }} gap={6}>
          <Stack spacing={6} flex={1}>
            {items
              .filter((_, i) => i % 2 === 0)
              .map((item, i) => (
                <Box key={`left-${i}`}>{item}</Box>
              ))}
          </Stack>
          <Stack spacing={6} flex={1}>
            {items
              .filter((_, i) => i % 2 !== 0)
              .map((item, i) => (
                <Box key={`right-${i}`}>{item}</Box>
              ))}
          </Stack>
        </Box>
      </Box>
    </DashboardLayout>
  )
}

export default Fegli
